import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import Header from "../../common/Header.js";
import Findcare1 from "../../../assets/images/findcare1.webp";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProcessImage from "../../../assets/images/Process.webp";
import personalized1 from "../../../assets/images/personalized1.webp";
import personalized2 from "../../../assets/images/personalized2.webp";
import personalized3 from "../../../assets/images/personalized3.webp";
import personalized4 from "../../../assets/images/personalized4.webp";

const FindCare = () => {
  const navigate = useNavigate();

  const handlePostJob = () => {
    localStorage.setItem("postJobCare", true);
    navigate(routes.login);
  };

  return (
    <>
      <Header></Header>
      <div className="care-slider-section">
        <div className="care-slider-item">
          <div className="care-slider-bg">
            <img src={Findcare1} alt="Care Exchange Blog Banner" />
          </div>
          <div className="care-slider-content-area">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="care-banner-circle">
                    <div className="care-slider-content">
                      <h1 className="care-slider-title">
                        Hire a Caregiver Online You Can Trust and Rely On
                      </h1>
                      <p className="care-slider-desc">
                        Care-Exchange helps you connect with trusted,
                        compassionate caregivers who match your unique needs.
                        Post your job, discover expert caregivers near you, and
                        hire the one who truly cares.
                      </p>
                    </div>
                    <Link className="care-slider-btn" to={routes.login}>
                      Find Your Right Caregiver Today
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="whychoose-section">
        <div className="container">
          <div className="whychoose-page-heading">
            <h2>Why Choose Care-Exchange for Finding the Right Caregiver</h2>
          </div>
          <div className="whychoose-page-content">
            <div className="row g-1">
              <div className="col-md-3">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">01</div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Personalized Matches</h3>
                    <p>
                      Find the right caregivers who are experienced & expert.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">02</div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Fast & Easy</h3>
                    <p>
                      Post your job in minutes and get quick responses from
                      caregivers.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">03</div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Transparent Profiles</h3>
                    <p>
                      Browse caregiver details & reviews before making a choice
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">04</div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Safe & Secure</h3>
                    <p>
                      Your privacy, safety & trust are our top priority at every
                      step.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="Process-section">
        <div className="container">
          <div className="Process-page-heading">
            <h2>Process to Connect with the Right Caregiver</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="Process-box">
                <div className="steps" role="list">
                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C20.73 21.22 19.46 22 18 22C16.97 22 16.04 21.61 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.92 14.43 15.93 15.13 15.21C15.86 14.46 16.88 14 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.4897 17.98H16.5098"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18 16.52V19.51"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Create Your Account</h3>
                      <p>
                        Get started in minutes — no complicated setup required.
                      </p>
                    </div>
                  </div>

                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.0399 3.02001L8.15988 10.9C7.85988 11.2 7.55988 11.79 7.49988 12.22L7.06988 15.23C6.90988 16.32 7.67988 17.08 8.76988 16.93L11.7799 16.5C12.1999 16.44 12.7899 16.14 13.0999 15.84L20.9799 7.96001C22.3399 6.60001 22.9799 5.02001 20.9799 3.02001C18.9799 1.02001 17.3999 1.66001 16.0399 3.02001Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.9099 4.14999C15.5799 6.53999 17.4499 8.40999 19.8499 9.08999"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Post Your Care Requirement</h3>
                      <p>
                        Tell us what kind of help you need — hours, tasks,
                        special skills, and location.
                      </p>
                    </div>
                  </div>

                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26018 15 12.0002 15"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.2 21.4C19.9673 21.4 21.4 19.9673 21.4 18.2C21.4 16.4327 19.9673 15 18.2 15C16.4327 15 15 16.4327 15 18.2C15 19.9673 16.4327 21.4 18.2 21.4Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 22L21 21"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Review Caregiver Profiles</h3>
                      <p>
                        Browse verified profiles, check experience,
                        certifications, background checks, and shortlist
                        candidates.
                      </p>
                    </div>
                  </div>

                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_240_4385)">
                          <path
                            d="M25 19L20 24L12 22L5 17"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.08496 8.82875L16 7L22.915 8.82875"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.29634 7.55248L1.10634 13.935C0.987789 14.172 0.968197 14.4465 1.05187 14.698C1.13555 14.9495 1.31565 15.1575 1.55259 15.2762L5.00009 17L9.08509 8.82873L5.63884 7.10623C5.5214 7.04733 5.3935 7.01216 5.26246 7.00271C5.13142 6.99326 4.9998 7.00973 4.87512 7.05117C4.75045 7.09262 4.63516 7.15822 4.53585 7.24424C4.43654 7.33025 4.35515 7.435 4.29634 7.55248Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M27 17L30.4475 15.2762C30.6845 15.1575 30.8646 14.9495 30.9483 14.698C31.0319 14.4465 31.0123 14.172 30.8938 13.935L27.7038 7.55248C27.645 7.435 27.5636 7.33025 27.4643 7.24424C27.365 7.15822 27.2497 7.09262 27.125 7.05117C27.0003 7.00973 26.8687 6.99326 26.7377 7.00271C26.6066 7.01216 26.4787 7.04733 26.3613 7.10623L22.915 8.82873L27 17Z"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M23.0001 9H18.0001L12.2926 14.5363C12.1865 14.6423 12.1056 14.7709 12.0559 14.9124C12.0063 15.054 11.9891 15.2049 12.0056 15.354C12.0222 15.5031 12.0721 15.6465 12.1516 15.7737C12.2312 15.9009 12.3383 16.0086 12.4651 16.0888C14.6538 17.4875 17.6251 17.3912 20.0001 15L25.0001 19L27.0001 17"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.5075 27L10.2925 25.6963L7 23.3438"
                            stroke="black"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_240_4385">
                            <rect width="32" height="32" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div>
                      <h3>Hire</h3>
                      <p>
                        Connect, interview, and hire the perfect fit with full
                        assurance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="proeess-media">
                <img src={ProcessImage} alt="" />
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <button
              onClick={() => handlePostJob()}
              type="button"
              className="btn-gr"
            >
              Start Posting Your Care Job Now
            </button>
          </div>
        </div>
      </div>

      <div className="personalized-section">
        <div className="container">
          <div className="personalized-page-heading">
            <h2>Get Personalized In-Home Care Solutions for Every Need</h2>
          </div>
          <div className="personalized-page-content">
            <div className="row">
              <div className="col-md-3">
                <div className="personalized-box">
                  <div className="personalized-head">
                    <h3>Child Care</h3>
                    <p>
                      Find nurturing caregivers who make every day fun, safe,
                      and full of learning.
                    </p>
                  </div>
                  <div className="personalized-featured-media">
                    <img
                      src={personalized1}
                      alt="Care Exchange Blog Banner"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="personalized-box">
                  <div className="personalized-head">
                    <h3>Medical Care</h3>
                    <p>
                      Get support from professionals trained to assist with
                      daily medical & health routines.
                    </p>
                  </div>
                  <div className="personalized-featured-media">
                    <img
                      src={personalized2}
                      alt="Care Exchange Blog Banner"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="personalized-box">
                  <div className="personalized-head">
                    <h3>Pet Care</h3>
                    <p>
                      Reliable, loving care for your furry family members when
                      you’re away.
                    </p>
                  </div>
                  <div className="personalized-featured-media">
                    <img
                      src={personalized3}
                      alt="Care Exchange Blog Banner"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="personalized-box">
                  <div className="personalized-head">
                    <h3>Senior Care</h3>
                    <p>
                      Need a caregiver for the elderly at home? Connect with
                      compassionate experts.
                    </p>
                  </div>
                  <div className="personalized-featured-media">
                    <img
                      src={personalized4}
                      alt="Care Exchange Blog Banner"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="testimonials-page-section">
        <div className="container">
          <div className="testimonials-page-heading">
            <h2>What Our Users Are Saying About Finding Caregivers</h2>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "Posting my care job took very little time, and within a day,
                  I found a wonderful in-home caregiver. Care-Exchange made
                  everything effortless!"
                </p>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "I was nervous about trusting someone new, but Care-Exchange
                  gave me good profiles and reviews. I found exactly the trusted
                  caregiver needed for my mom."
                </p>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "As a working parent, I struggled to balance everything.
                  Care-Exchange helped me find a kind, dependable caregiver who
                  treats my kids like family."
                </p>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "I found an in-home caregiver needed for my father within two
                  days! The process was transparent, fast, and stress-free.
                  Highly recommend Care-Exchange."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <div className="container">
          <div className="faq-page-heading">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-page-accordion">
            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                How does Care-Exchange help me find the right caregiver?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Our platform connects you with trusted caregivers based on
                  your requirements and location, ensuring a perfect match every
                  time.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Can I trust the caregivers listed on Care-Exchange?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Absolutely. Each caregiver undergoes a thorough background
                  check, identity verification, and skill review.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                What types of care can I find here?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  You can find caregivers for child care, senior care, pet care,
                  and medical care, all under one platform.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                How long does it take to hire a caregiver?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Many care seekers find their ideal match within 24-48 hours
                  after posting their job.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      <div className="post-job-section">
        <div className="container">
          <h5 className="fw-bold mb-3">
            Ready to Find a Caregiver You Can Trust?
          </h5>
          <p className="lead mb-4">
            Care-Exchange makes it easy, quick & secure. Don’t Wait- The Right
            Caregiver Is Just a Click Away!
          </p>
          <button
            onClick={() => handlePostJob()}
            type="button"
            className="btn-gr"
          >
            Post My Job Now
          </button>
        </div>
      </div>

      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FindCare;
